import { useMutation } from '@zg-rentals/react-query5';
import { useDispatch } from 'react-redux';

import makeRequest from '../../utils/makeRequestUtils';
import useRequestConfig from '../../hooks/useRequestConfig';

import { RENTAL_MANAGER_API_V1_PREFIX } from '../../constants/RouteConstants';

const useConvertSingleFamilyToRoomForRent = () => {
  const dispatch = useDispatch();
  const requestConfig = useRequestConfig();

  const queryFn = (propertyId: string) =>
    makeRequest({
      dispatch,
      endpoint: `${RENTAL_MANAGER_API_V1_PREFIX}/users/properties/convert/singleFamilyToRoomForRent`,
      requestConfig,
      config: { params: { propertyId } },
    });

  return useMutation({ mutationFn: (data: string) => queryFn(data) });
};

export { useConvertSingleFamilyToRoomForRent };
